import React, {useEffect, useState, useRef} from 'react';
import {useFormContext, useFieldArray, useWatch} from 'react-hook-form';
import {companyPropTypes, companyDefaultProps} from './panelProps';
import CustomFormBlock from '../../../pieces/inputs/formBlock';
import * as allConstants from '../../../constants/allConstants';
import Grid from '@mui/material/Grid';
import {Box, Card, CardContent, List, Typography, ListItem, Button} from '@mui/material';
import {useCompanyPageStyles} from '../companyPageStyles';
import {globalUseClasses} from '../../../styles/globalClasses';
import {inputTypes} from '../../../pieces/inputs/formInput';
import base_url from '../../../baseUrls';
import Utils from '../../../utils/utils';
import {NotAllowedToEditSection} from './notAllowedToEditSection';
import { AutoCompleteComponent} from '@syncfusion/ej2-react-dropdowns';
import { DataManager, Query, UrlAdaptor } from '@syncfusion/ej2-data';
import ApiUtils from '../../../utils/apiUtils';
import {isIpermitUser} from '../../../permissions/utils';
import './companySettings.css';
import Spacer from '../../../pieces/spacer';

class CustomUrlAdaptor extends UrlAdaptor {

  // Override the processResponse method
  processResponse(data, success) {

      //console.log("return data => ", data);
      if (success) {
         return data.data;
      } else {
         // Handle errors or failed requests
         console.error('Request failed:', data);
         return [];
      }
  }
}
export const CompanySettings = (props)=> {
  const [init] = useState(true);
  const [companyDataMgr, setCompanyDataMgr] = useState([]);
  const [companyAdminOptions, setCompanyAdminOptions] = useState([]);

  const [availableRegions, setAvailableRegions] = useState([]);
  const [parentCompanyName, setParentCompanyName] = useState();
  const classes = {...useCompanyPageStyles(), ...globalUseClasses()};
  const COMPANY_FIELDS = allConstants.COMPANY_FIELDS;
  const CHILD_COMPANY_FIELDS = allConstants.CHILD_COMPANY_FIELDS;
  const parentCompanyField = COMPANY_FIELDS.PARENT_COMPANY.api_name;

  let authToken = useRef(null);
  const queryCompany = new Query().take(30).skip(0);

  const formMethods = useFormContext();

  // const getCompanyData = ()=> {
  //   const initialData = props.tabProps?.companyData || {};

  //   // console.log('initial data');
  //   // console.log(initialData);
  //   // console.log('form values');
  //   // console.log(formMethods.getValues());

  //   return {...initialData, ...formMethods.getValues()};
  // };

  //const companyData = getCompanyData();

  const companyData =props.tabProps?.companyData || {};
  const isExistingCompany = !props.tabProps?.isIpermitInvite && !props.tabProps?.isSelfRegistering && Boolean(companyData?.id);
  const canSeeOnyxIds = isIpermitUser(props.tabProps?.user?.role);


  //console.log('company data');
  //console.log(companyData);

  const selectedState = useWatch({
    name: `${COMPANY_FIELDS.LOCATION.api_name}`,
    control: formMethods.control
  });

  useEffect ( async () => {

    authToken.current = await ApiUtils.getAccessToken();
    const urlCompany = `${base_url.api}companies/autocomplete`;

    const compDataMgr = new DataManager({
        url: urlCompany,
        adaptor: new CustomUrlAdaptor(),
        crossDomain: true,
        offline: false,
        headers: [ {'Authorization': authToken.current}],
        onFailure: (e) => {
            console.error('API call failed', e);
        }
    });
    setCompanyDataMgr(compDataMgr);

  }, [init]);

  useEffect(() => {
    const parent = companyData?.[COMPANY_FIELDS.PARENT_COMPANY.api_name];
    const parentId = parent?.[CHILD_COMPANY_FIELDS.COMPANY_ID.api_name];
    const parentName = parent?.[CHILD_COMPANY_FIELDS.COMPANY_NAME.api_name] || parent?.companyName || '';

    setParentCompanyName(parentName);
    formMethods.setValue(
      `${parentCompanyField}.${CHILD_COMPANY_FIELDS.COMPANY_ID.api_name}`,
      parentId || '',
      {shouldDirty: false, shouldTouch: false}
    );
    formMethods.setValue(
      `${parentCompanyField}.${CHILD_COMPANY_FIELDS.COMPANY_NAME.api_name}`,
      parentName,
      {shouldDirty: false, shouldTouch: false}
    );
  }, [
    companyData?.[COMPANY_FIELDS.PARENT_COMPANY.api_name]?.[CHILD_COMPANY_FIELDS.COMPANY_ID.api_name],
    companyData?.[COMPANY_FIELDS.PARENT_COMPANY.api_name]?.[CHILD_COMPANY_FIELDS.COMPANY_NAME.api_name],
  ]);

  useEffect ( async () => {

    //console.log('selected state');
    //console.log(selectedState);

    let stateName = '';
    if (selectedState && selectedState.length) {
      stateName = selectedState[0];
    }
  
    if (stateName === '') {
      return;
    }
   
    const response = await ApiUtils.makeApiCall('POST', `states/get-region-key-values`, JSON.stringify({stateName: stateName}) );

    if(response?.status === 'success') {
      setAvailableRegions(response.data.regions);

      //return AutocompleteFields[field].responseKey ? response.data[AutocompleteFields[field].responseKey] : response.data;


    }
  }, [selectedState]);

  useEffect(()=> {
    const fetchCompanyUsers = async ()=> {
      if(!isExistingCompany || !companyData?.id) {
        setCompanyAdminOptions([]);
        return;
      }
      const response = await ApiUtils.makeApiCall('GET', `companies/get-users-by-company-id/${companyData.id}`);

      if(response?.status === 'success') {
        const options = (response?.data?.users || []).map((user)=> {
          const fullName = `${user?.firstName || ''} ${user?.lastName || ''}`.trim();
          const withEmail = user?.email ? `${fullName || user.email} (${user.email})` : fullName;
          return {
            name: withEmail || user?._id,
            value: user?._id,
          };
        });
        setCompanyAdminOptions(options);
      }
    };
    fetchCompanyUsers();
  }, [isExistingCompany, companyData?.id]);

  const getDefaultValue = (field, parent = null) => {
    if (parent) {
      return companyData?.[parent]?.[field];
    }
    return companyData?.[field];
  };

  const getAdminUserDefaultValue = ()=> {
    const adminUserValue = companyData?.[COMPANY_FIELDS.ADMIN_USER_ID.api_name];
  
    if(typeof adminUserValue === 'string') {
      return adminUserValue;
    }
    return adminUserValue?.id || '';
  };

  const allowedTests = useWatch({
    name: COMPANY_FIELDS.ALLOWED_TESTS.api_name,
    control: formMethods.control
  }) || getDefaultValue(COMPANY_FIELDS.ALLOWED_TESTS.api_name) || [];

  const showHersRequireDefault = Array.isArray(allowedTests) &&
    allowedTests.some((test) => {
      if (typeof test === 'string') {
        return test.toUpperCase() === allConstants.TEST_TYPES.HERS.value;
      }
      return test?.value?.toUpperCase?.() === allConstants.TEST_TYPES.HERS.value;
    });
  const showCheckEucAsDefault = Array.isArray(allowedTests) &&
    allowedTests.some((test) => {
      if (typeof test === 'string') {
        return test.toUpperCase() === allConstants.TEST_TYPES.EUC.value;
      }
      return test?.value?.toUpperCase?.() === allConstants.TEST_TYPES.EUC.value;
    });

  const commonFieldProps = {
    fullWidth: true,
    maxWidth: '100%'
  };

  const companyCollectionName = COMPANY_FIELDS.CHILD_COMPANIES.api_name;

  const companyRow = {
    [CHILD_COMPANY_FIELDS.COMPANY_ID.api_name]: null,
    [CHILD_COMPANY_FIELDS.COMPANY_NAME.api_name]: '',
  };

  const {fields, append} = useFieldArray({
    control: formMethods.control,
    name: companyCollectionName,
  });

  const companySubformDefaultProps = (index) => ({
    defaultValue: '',
    isEditable: true,
    nested: true,
    fullWidth: true,
    parent: `${companyCollectionName}[${index}]`
  });

  const deleteCompanyRow = (index) => {
    try {
      const childCompanies = [...formMethods.getValues()?.[allConstants.COMPANY_FIELDS.CHILD_COMPANIES.api_name]];
      childCompanies.splice(index, 1);
      formMethods.setValue(allConstants.COMPANY_FIELDS.CHILD_COMPANIES.api_name, childCompanies);
    } catch(e){

    }
  };

  const clearParentCompanyFields = () => {
    formMethods.setValue(`${parentCompanyField}.${CHILD_COMPANY_FIELDS.COMPANY_ID.api_name}`, '');
    formMethods.setValue(`${parentCompanyField}.${CHILD_COMPANY_FIELDS.COMPANY_NAME.api_name}`, '');
    formMethods.setValue(`${parentCompanyField}.${CHILD_COMPANY_FIELDS.HIERARCHY.api_name}`, '');
    setParentCompanyName('');
  };

  const isParentCompanyValueEmpty = (value) => {
    return value === null || value === undefined || String(value).trim() === '';
  };

  const onChangeCompany = (args) => {
    if (args.itemData) {
      formMethods.setValue(`${parentCompanyField}.${CHILD_COMPANY_FIELDS.COMPANY_ID.api_name}`, args.itemData.companyId);
      formMethods.setValue(`${parentCompanyField}.${CHILD_COMPANY_FIELDS.COMPANY_NAME.api_name}`, args.itemData.companyName);
      formMethods.setValue(`${parentCompanyField}.${CHILD_COMPANY_FIELDS.HIERARCHY.api_name}`, args.itemData.hierarchy);
      setParentCompanyName(args.itemData.companyName);
      return;
    }

    // Syncfusion fires change without itemData while filtering/typing; only clear on an empty value.
    if (isParentCompanyValueEmpty(args.value)) {
      clearParentCompanyFields();
    }
  };

  const onParentCompanyInput = (args) => {
    if (isParentCompanyValueEmpty(args?.value ?? args?.target?.value)) {
      clearParentCompanyFields();
    }
  };

  const getNextAutoEmail = async () => {
 
    const response = await ApiUtils.makeApiCall('GET', `users/get-next-auto-email`);

    if(response?.status === 'success') {
      formMethods.setValue(`${[COMPANY_FIELDS.EMAIL.api_name]}`, response.data);     
    }
  }

  

  return (
    <>
      <style>

      </style>
      <Grid container maxWidth={'100%'} spacing={3}>
        <NotAllowedToEditSection show={props.tabProps.notAllowedToEdit}/>
        <Grid item sm={12} md={6}>
          <Card className={classes.card_block}>
            <CardContent className={classes.half_width}>
              <CustomFormBlock
                {...props.inputDefaultProps}
                {...commonFieldProps}
                field={COMPANY_FIELDS.NAME}
                defaultValue={getDefaultValue(COMPANY_FIELDS.NAME.api_name)}
              />
              {isExistingCompany && <CustomFormBlock
                key={`companyAdmin_${getAdminUserDefaultValue()}_${companyAdminOptions.length}`}
                {...props.inputDefaultProps}
                {...commonFieldProps}
                field={COMPANY_FIELDS.ADMIN_USER_ID}
                inputType={inputTypes.singleSelect}
                options={companyAdminOptions}
                defaultValue={getAdminUserDefaultValue()}
              />}
              <Box className={classes.two_col_container_fill_left}>
                <CustomFormBlock
                  {...props.inputDefaultProps}
                  {...commonFieldProps}
                  field={COMPANY_FIELDS.EMAIL}
                  width={'100%'}
                  defaultValue={getDefaultValue(COMPANY_FIELDS.EMAIL.api_name)}
                />
                <Button variant={'outlined'}
                  sx={{width: '90px', height: '28px', marginTop:'10px'}}
                  className={'blue'}
                  color={'primary'}
                  onClick={(e)=> {getNextAutoEmail()}}
                >Generate</Button>
              </Box>
              {props.tabProps.isIpermitInvite && <CustomFormBlock
                {...props.inputDefaultProps}
                field={COMPANY_FIELDS.STATE_LICENSE_NUMBER}
                nested={true}
                parent={COMPANY_FIELDS.STATE_LICENSE.api_name}
                fullWidth={true}
                defaultValue={getDefaultValue(COMPANY_FIELDS.STATE_LICENSE_NUMBER.api_name, COMPANY_FIELDS.STATE_LICENSE.api_name)}
              />
              }
              <CustomFormBlock
                {...props.inputDefaultProps}
                {...commonFieldProps}
                field={COMPANY_FIELDS.LOCATION}
                inputType={inputTypes.multiSelect}
                width={'100%'}
                options={Utils.getOptions(props?.tabProps?.options?.markets)}
                defaultValue={getDefaultValue(COMPANY_FIELDS.LOCATION.api_name)}
              />
              <CustomFormBlock
                {...props.inputDefaultProps}
                {...commonFieldProps}
                field={COMPANY_FIELDS.MARKET_AREA}
                inputType={inputTypes.multiSelect}
                width={'100%'}
                options={Utils.getOptions(availableRegions)}
                defaultValue={getDefaultValue(COMPANY_FIELDS.MARKET_AREA.api_name)}
              />
              <CustomFormBlock key={JSON.stringify(getDefaultValue(COMPANY_FIELDS.ALLOWED_TESTS.api_name))}
                  {...props.inputDefaultProps}
                  {...commonFieldProps}
                  field={COMPANY_FIELDS.ALLOWED_TESTS}
                  inputType={inputTypes.multiSelect}
                  width={'100%'}
                  options={Utils.getOptions(allConstants.TEST_TYPES)}
                  defaultValue={getDefaultValue(COMPANY_FIELDS.ALLOWED_TESTS.api_name)}
                />
              <Box className={classes.two_col_container}>
                {showHersRequireDefault && <CustomFormBlock
                  {...props.inputDefaultProps}
                  {...commonFieldProps}
                  renderLabel={false}
                  labelLeft={true}
                  field={COMPANY_FIELDS.HERS_REQUIRE_DEFAULT}
                  inputType={inputTypes.checkbox}
                  defaultValue={getDefaultValue(COMPANY_FIELDS.HERS_REQUIRE_DEFAULT.api_name)}
                />}
                {showCheckEucAsDefault && 
                  <CustomFormBlock
                    {...props.inputDefaultProps}
                    {...commonFieldProps}
                    renderLabel={false}
                    labelLeft={true}
                    field={COMPANY_FIELDS.CHECK_EUC_AS_DEFAULT}
                    inputType={inputTypes.checkbox}
                    defaultValue={getDefaultValue(COMPANY_FIELDS.CHECK_EUC_AS_DEFAULT.api_name)}
                />}
              </Box>
              <CustomFormBlock
                {...props.inputDefaultProps}
                {...commonFieldProps}
                field={COMPANY_FIELDS.ALLOWED_PERMITS}
                inputType={inputTypes.multiSelect}
                options={Utils.getOptions(allConstants.JOB_TYPES)}
                width={'100%'}
                defaultValue={getDefaultValue(COMPANY_FIELDS.ALLOWED_PERMITS.api_name)}
              />
              <CustomFormBlock
                  {...props.inputDefaultProps}
                  {...commonFieldProps}
                  field={COMPANY_FIELDS.HOME_DEPOT_ID}
                  width={'100%'}
                  defaultValue={getDefaultValue(COMPANY_FIELDS.HOME_DEPOT_ID.api_name)}
              />
            </CardContent>
          </Card>
        </Grid>
        <Grid item sm={12} md={6} flex={1}  >
          <Card className={classes.card_block}>
            <CardContent>
              <div className="box-container" style={{maxWidth: '500px'}}>
                <label className="box-label">{COMPANY_FIELDS.PARENT_COMPANY.label}</label>
                <Box sx={{
                  border: '2px solid lightgrey',
                  padding: '4px',
                  borderRadius: '4px',
                  width: '100%',
                  position: 'relavtive',
                }} >
                  {companyDataMgr &&
                  <AutoCompleteComponent id={COMPANY_FIELDS.PARENT_COMPANY.label} sortOrder="Ascending"
                    dataSource={companyDataMgr} query={queryCompany} fields={{value: 'companyName', text: 'companyName'}}
                    enabled={!props.inputDefaultProps.viewMode}
                    value={parentCompanyName} minLength={3} filterType='Contains'
                    change={onChangeCompany} input={onParentCompanyInput}
                    style={{borderRadius: '8px', width: '100%', paddingLeft: '4px'}}/>
                  }
                </Box>
              </div>
              <CustomFormBlock
                {...props.inputDefaultProps}
                {...commonFieldProps}
                parent={COMPANY_FIELDS.PARENT_COMPANY.api_name}
                field={CHILD_COMPANY_FIELDS.COMPANY_ID}
                defaultValue={getDefaultValue(CHILD_COMPANY_FIELDS.COMPANY_ID.api_name, COMPANY_FIELDS.PARENT_COMPANY.api_name)}
                hide={true}
              />
              <Spacer y={1} />
              <CustomFormBlock
                {...props.inputDefaultProps}
                {...commonFieldProps}
                field={COMPANY_FIELDS.HIERARCHY}
                inputType={inputTypes.singleSelect}
                options={Utils.getOptions(allConstants.HIERARCHY_TYPES)}
                maxWidth={'500px'}
                defaultValue={getDefaultValue(COMPANY_FIELDS.HIERARCHY.api_name)}
              />
              <Box mb={1}>
                <Typography className={classes.eq_name}>{COMPANY_FIELDS.CHILD_COMPANIES.label}</Typography>
              </Box>
              <form>
                <List>
                  {fields.map((item, index) => (
                    <ListItem key={item.id} sx={{
                      display: 'grid',
                      paddingTop: '0',
                      paddingBottom: '0',
                      gridTemplateColumns: '2fr 0.5fr',
                      gap: '8px',
                      alignItems: 'flex-start'
                    }}>
                      <CustomFormBlock
                        {...props.inputDefaultProps}
                        {...commonFieldProps}
                        {...companySubformDefaultProps(index)}
                        field={{...CHILD_COMPANY_FIELDS.COMPANY_NAME, ...{required: false}}}
                        inputType={inputTypes.autoComplete}
                        autocompleteParams={{
                          url: `${base_url.api}childCompanies/autocomplete`,
                          getRequestParams: (value)=> {
                            if(value) {
                              return {
                                name: value
                              };
                            }
                          },
                          collectionName: companyCollectionName,
                          fill: [CHILD_COMPANY_FIELDS.COMPANY_ID],
                          filter: (options)=> {
                            const existingRows = formMethods.getValues()?.[allConstants.COMPANY_FIELDS.CHILD_COMPANIES.api_name];
                            if(!existingRows) return options;
                            const existingProducts = existingRows.map((row)=> row[CHILD_COMPANY_FIELDS.COMPANY_NAME.api_name]);
                            return options.filter((option)=> !existingProducts.includes(option[CHILD_COMPANY_FIELDS.COMPANY_NAME.api_name]));
                          }
                        }
                        }
                      />
                      <CustomFormBlock
                        {...props.inputDefaultProps}
                        {...commonFieldProps}
                        {...companySubformDefaultProps(index)}
                        field={CHILD_COMPANY_FIELDS.COMPANY_ID}
                        hide={true}

                      />
                      {/* {!props.inputDefaultProps.viewMode && <DeleteRowButton eqName={'childCompanies'} index={index} 
                        extraStyles={{alignSelf: 'baseline',
                          top: '8px',
                          position: 'relative',
                          padding: '0'
                        }}
                        deleteAction={() => deleteCompanyRow(index)}
                      />} */}
                    </ListItem>
                  ))}
                </List>
                {/* {!props.inputDefaultProps.viewMode && props.inputDefaultProps.isEditable &&
                <AddRowButton eqName={'childCompanies'} variant={variants.textWithIcon}
                  addAction={() => {
                    append({...companyRow});
                  }}
                />} */}
              </form>
              {canSeeOnyxIds && <Box className={classes.two_col_container}>
                <CustomFormBlock
                  {...props.inputDefaultProps}
                  {...commonFieldProps}
                  field={COMPANY_FIELDS.ONYX_BUILDER_ID}
                  fullWidth={true}
                  defaultValue={getDefaultValue(COMPANY_FIELDS.ONYX_BUILDER_ID.api_name)}
                />
                <CustomFormBlock
                  {...props.inputDefaultProps}
                  {...commonFieldProps}
                  field={COMPANY_FIELDS.ONYX_SUBDIVISION_ID}
                  fullWidth={true}
                  defaultValue={getDefaultValue(COMPANY_FIELDS.ONYX_SUBDIVISION_ID.api_name)}
                />
              </Box>}

            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

CompanySettings.propTypes = companyPropTypes;
CompanySettings.defaultProps = companyDefaultProps;
